import { SENS_ACHAT, MODULE_ACHAT } from '@/configuration/devisConf';

export default function genererCritereRechercheLotPaiement() {
  return {
    auto: null,
    societeId: null,
    exporteeEnCompta: null,
    etat: [],
    sens: SENS_ACHAT,
    datesRemise: {
      dateDebut: null,
      dateFin: null,
    },
    domiciliationBancaireIds: [],
    modesReglementsIds: [],
    module: MODULE_ACHAT,
  };
}
